module.exports = __webpack_public_path__ + "static/media/24hrs.e65fbbab.svg";